import { render } from "./LanguageSwitcher.vue?vue&type=template&id=1960a3a1&scoped=true"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=1960a3a1&scoped=true&lang=css"

import exportComponent from "D:\\gitrepos\\QNBPayHelp\\apidocs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1960a3a1"]])

export default __exports__